<h1 i18n="@@privacy_headline">
    Privacy policy
</h1>
<p>We are glad that you are interested in our website. We regard the protection of your private sphere as very
    important. In
    the paragraphs below we tell you in detail of how we handle your data.</p>
<h2>Personal contact for data protection</h2>
<p>Should you have any questions about the collection, processing or use of your personal details and data, should you
    require
    information, correction, blockage or deletion of your data, or revocation of authorisation previously given, please
    contact:</p>
<p>Stefanie Hering-Berlin GmbH
    <br/> Stefanie Hering
    <br/> Potsdamer Strasse 98
    <br/> 10785 Berlin
    <br/>
</p>
<h2>Data security</h2>
<p>Your personal details and data will be transmitted via the internet in an encrypted state during the order process.
    We secure
    our website and other systems through technical and organisational methods against loss, destruction, access,
    alteration
    and dissemination of your data by unauthorised persons. You should treat your access information as confidential at
    all
    times and close your browser window when you have finished communicating with us, particularly if you use the
    computer
    jointly with other people.</p>
<h2>Collection, processing and use of your personal details and data</h2>
<p>You can visit our site without providing any personal information. We only store access data – even if your visit
    comes via
    newsletter links – without any personal reference, e.g.:</p>
<ul>
    <li>the name of your internet service provider</li>
    <li>the site from which you visit us</li>
    <li>the name of the file requested.</li>
</ul>
<p>These data are evaluated solely in order to improve our service and allow no conclusions to be drawn about you
    personally.</p>
<p>We collect, store and process your data to deal with your purchase order and to handle any later guarantee
    transactions,
    and for advertising purposes. Personal details and data will be collected if you voluntarily notify us of them when
    ordering
    your goods, or when opening a customer account, or when registering for the Newsletter. </p>
<p>In executing your order, we shall pass on your personal details and data to service providers in our employ
    (carriers, providers
    of logistics and payment services).</p>
<h2>Right to information and correction</h2>
<p>Under the German Data Protection Act you have a right to information free of charge about your data in storage, and
    if necessary
    a right to correction, blockage or deletion of these data.</p>
<h2>Use of cookies</h2>
<p>We employ so-called cookies on our website. Cookies are small electronic files which are saved on your data carrier
    and store
    the particular settings and data for exchange of information with our system via your browser. This storage helps us
    to design the website with your needs in mind and makes it easier to use by, for example, saving particular inputs
    which
    you have already made so that you do not have to keep repeating them. Your browser enables you to restrict the use
    of
    cookies by making certain adjustments, but such adjustments may mean that our site no longer functions for you, or
    is
    restricted in its functioning. Cookies can also be deleted there.</p>
<h3>Session cookies</h3>
<p>Session cookies are deleted once you have closed your browser.</p>
<h3>Long-time cookies</h3>
<p>We use cookies which stay on your hard disk. For your convenience, their expiry date is set to a date in the future.
    If you
    make a further visit, it is possible to recognise immediately that you have already been with us and which inputs
    and
    settings you prefer.</p>
<h2>External services and service providers</h2>
<p>To optimise our service, we use various external facilities and service providers.</p>
<h3>Cloudflare</h3>
<p>This website uses services provided by CloudFlare. The services are offered by</p>
<p>
    CloudFlare, Inc.
    <br/> 665 3rd St. #200
    <br/> San Francisco, CA 94107
    <br/> USA
</p>
<p>CloudFlare provides a globally distributed Content Delivery Network containing Domain Name Services (DNS).
    Communication
    between your browser and this website is routed through the CloudFlare network. By doing so, CloudFlare is able to
    analyse
    data transferred between users and our websites, in order to predict and prevent attacks or bogus activities aimed
    at
    our services. Furthermore CloudFlare might store cookies on your system in order to optimise and analyse services
    provided.
    Further information can be found in the CloudFlare security policy:</p>
<p>https://www.cloudflare.com/security-policy/</p>
<p>Explanations on data collected by CloudFlare can be found here:</p>
<p>https://blog.cloudflare.com/what-cloudflare-logs/</p>
<h3>Google Analytics with the "anonymise IP" extension</h3>
<p>This website uses Google Analytics for web analysis. This is a service provided by Google Inc. (“Google”).</p>
<p>Google Analytics uses cookies to trace your visit, and to get information about the use of this website, including
    your anonymised
    IP address, will be transmitted to a server operated by Google in the USA, and stored there. Google complies with
    the
    data-protection provisions of the US Safe Harbour Convention and is registered with the Safe Harbour Programme of
    the
    US Department of Commerce. Google will use this information to evaluate your use of the website, to assemble reports
    for us about activity on the website, and to supply us with further services associated with use of the website and
    use
    of the internet.</p>
<p>Google may transmit this information to Third Parties insofar as this is required by law or insofar as Third Parties
    will
    process these data to Google’s order. Google will not combine your IP address with other data of Google. You can
    prevent
    the storage of cookies by adjusting your browser software to this effect. Please note, however, that in such case
    you
    may not be able to use all the functions of this website in full.</p>
<p>If you do not wish for information about your visit to this website to be transmitted to Google, you have the
    facility to
    install a “deactivation add-on” for your browser. We have also carried out settings under which Google Analytics
    deletes
    the last part of the IP addresses of visitors to our website. In this way, no conclusions can be drawn about you
    personally.</p>
<h3>Google Tag Manager and Google AdWords conversion tracking</h3>
<p>Google Tag Manager enables us to measure the reach of our online advertising. No personal details or data are
    processed via
    this tool or the cookies pertaining to it. You can inspect further information about Google Tag Manager and its
    usage
    guidelines at the following link:</p>
<p>https://www.google.de/tagmanager/use-policy.html</p>
<p>Google AdWords conversion tracking is likewise a service provided by Google. It makes it possible, by use of cookies,
    to
    tell whether you reached our website via a Google advertisement. The information stored in cookies serves only to
    produce
    internal statistics and does not allow you to be identified personally. If you do not agree to the storage of
    cookies,
    you have a facility to prevent this via your browser settings. Alternatively, you can alter the settings via Google
    privacy
    settings, using the following link:</p>
<p>http://www.google.com/settings/ads</p>
<h3>Mandrill and MailChimp</h3>
<p>For e-mail dispatch we use two services, Mandrill and MailChimp, provided by MailChimp, 512 Means St. Suite 404,
    Atlanta,
    GA 30318, USA. These services enable us to manage e-mail contacts. We further obtain information to show when an
    e-mail
    which we have sent has been read or when links which it contains have been opened.</p>
<h3>BingAds</h3>
<p>In addition, our website uses the conversion tracking provided by BingAds Microsoft Corporation, One Microsoft Way,
    Redmond,
    WA 98052-6399, USA. In this process Microsoft BingAds places cookies on your instrument should you have reached our
    website
    via a Microsoft Bing advertisement. In this way both we and Microsoft Bing can tell which advertisement led to you
    reach
    our website (conversion tracking). No personal information relating to your identity is provided. You have a
    facility
    to prohibit this data processing by preventing the storage of cookies by adjusting your browser to that effect, but
    please
    note that in such case it will not be possible to use all the functions on our website in full. You will find
    further
    information on data protection and the cookies used by Microsoft Bing at:</p>
<p>https://privacy.microsoft.com/de-de/privacystatement/</p>
<p>on the Microsoft website.</p>
<h4>hCaptcha</h4>
<p>We use the hCaptcha anti-bot service (hereinafter "hCaptcha") on our website. This service is provided by Intuition Machines, Inc., a Delaware US Corporation ("IMI"). hCaptcha is used to check whether the data entered on our website (such as on a login page or contact form) has been entered by a human or by an automated program. To do this, hCaptcha analyzes the behavior of the website or mobile app visitor based on various characteristics. This analysis starts automatically as soon as the website or mobile app visitor enters a part of the website or app with hCaptcha enabled. For the analysis, hCaptcha evaluates various information (e.g. IP address, how long the visitor has been on the website or app, or mouse movements made by the user). The data collected during the analysis will be forwarded to IMI. hCaptcha analysis in the "invisible mode" may take place completely in the background. Website or app visitors are not advised that such an analysis is taking place if the user is not shown a challenge. Data processing is based on Art. 6(1)(f) of the GDPR (DSGVO): the website or mobile app operator has a legitimate interest in protecting its site from abusive automated crawling and spam. IMI acts as a "data processor" acting on behalf of its customers as defined under the GDPR, and a "service provider" for the purposes of the California Consumer Privacy Act (CCPA). For more information about hCaptcha and IMI's privacy policy and terms of use, please visit the following links: https://www.hcaptcha.com/privacy and https://www.hcaptcha.com/terms.</p>
<h2>Revoking authorisations</h2>
<p>We have noted and saved any authorisations which you may have given on our website, e.g. for subscription to an
    e-mail newsletter.
    You can ask us at any time to state the details of these authorisations. For this purpose, please communicate by
    e-mail
    with our personal contact for data protection as set out above. Please note that your authorisations, once given,
    can
    be revoked at any time with effect for the future.</p>
<h2>Amendment of this Data Protection Notice</h2>
<p>We reserve the right to amend this Data Protection Notice. The current version of the Data Protection Notice can be
    called
    up at any time at</p>
<p>https://www.heringberlin.com/privacy-policy-cookie-restriction-mode/.</p>
